import React from 'react';
import { useLanguage } from './LanguageContext';
import type { Locale } from './LanguageContext';

interface LanguageSwitcherProps {
  className?: string;
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ 
  className = '' 
}) => {
  const { locale, setLocale, t } = useLanguage();

  const handleToggle = () => {
    const newLocale: Locale = locale === 'fi' ? 'en' : 'fi';
    setLocale(newLocale);
  };

  return (
    <button
      onClick={handleToggle}
      className={` bg-auroraBorealis p-1 rounded
        text-xs text-sunsetSnow hover:text-geraniumSylvaticum transition-colors duration-200 font-medium font-mono
        ${className}
      `}
      title={`Switch to ${t('lang.switch')}`}
    >
      {locale.toUpperCase()}
    </button>
  );
};